'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('adminODDControllers')
    .factory('adminODDService', ['$http', '$q', function ($http) {

        var baseUrl = environment.apiUrl + '/Pilot/api/ODD/Administration';
        var service = {};

        service.launchEchoTest = function () {
            var reqUrl = baseUrl + '/LaunchEchoTest';

            return $http.get(reqUrl).then(function (response) { return response.data; });
        };

        service.getLastEchoTestResult = function () {
            var reqUrl = baseUrl + '/LastEchoTestResult';

            return $http.get(reqUrl).then(function (response) { return response.data; });
        };

        return service;

    }]);
